import React from 'react';
import IMG1 from '../../assets/WA.jpg';
import IMG2 from '../../assets/Invest.jpg';
import IMG3 from '../../assets/fest2.jpg';
import IMG4 from '../../assets/make.png';
import IMG5 from '../../assets/weather.jpg';


import './portfolio.css';

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: 'WhatsApp Home Automation',
      img: IMG1,
      description:
        'Developed a WhatsApp-based home automation system using Twilio API and ESP for effortless device control via messaging, enhancing user convenience and efficiency.',
      technologies: 'Arduino IDE | ESP8266',
      link: 'https://adventistlearningcenter-257375ab1970.herokuapp.com/',
      github: 'https://github.com/Meri-MG/school',
    },
    {
      id: 2,
      title: 'AOne Investor Club App',
      img: IMG2,
      description:
        'Developed a user-friendly app for real estate investment opportunities, ensuring secure handling of financial data while providing a smooth and intuitive user experience.',
      technologies: 'Flutter | Dart | Postman | PHP',
      link: 'https://fakestore-metrics.netlify.app/',
      github: 'https://github.com/Meri-MG/Fakestore---react',
    },
    {
      id: 3,
      title: 'College Fest App',
      img: IMG3,
      description: 'Designed an app to manage and register for technical, cultural, and sports events, integrating a scoring system to display real-time rankings and competition results.',
      technologies: 'Flutter | Dart | Node.js',
      link: 'https://meri-mg.github.io/To-Do-List/dist/',
      github: 'https://github.com/Meri-MG/To-Do-List',
    },
    {
      id: 4,
      title: 'Mail to WhatsApp Automation (Make.com)',
      img: IMG4,
      description:
        'Automated a Gmail to WhatsApp workflow using Make.com with AI-based email summarization, leveraging Google Sheets for data management and APIs for seamless message delivery.',
      technologies: 'WhatsApp API | Gmail Integration',
      link: 'https://meri-mg.github.io/shelter/pages/main/index.html',
      github: 'https://github.com/Meri-MG/shelter',
    },
    {
      id: 5,
      title: 'Weather App',
      img: IMG5,
      description:
        'Developed the Weather mobile app to provide real-time weather updates with a clean UI, ensuring accurate forecasts and an intuitive user experience.',
      technologies: 'Flutter | Dart',
      link: 'https://meri-mg.github.io/Unilab-world-news/',
      github: 'https://github.com/Meri-MG/Unilab-world-news',
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            {/* <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Visit Website
              </a>
            </div> */}
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
